import React, {useEffect, useState} from 'react';
import {AutoComplete, Card, Descriptions} from 'antd';
import api from "../api/api";

interface Player {
    no: string;
    zh_name: string;
    en_name: string;
    country: string;
    Nation: string;
    isRight: string;
    isStraight: string;
    faceType0: string;
    faceType1: string;
    gender: string;
}

const PlayerQuery: React.FC = () => {
    const [players, setPlayers] = useState<Player[]>([]);
    const [selectedPlayer, setSelectedPlayer] = useState<Player | null>(null);
    const [options, setOptions] = useState<{value: string, no: string}[]>([]);

    useEffect(() => {
        api.getPlayerNameDictList().then(setPlayers).catch(console.error);
    }, []);

    const handleSearch = (searchText: string) => {
        if (!searchText) {
            setOptions([]);
            return;
        }
        const filtered = players
            .filter(p => p.zh_name.includes(searchText) || p.en_name.toLowerCase().includes(searchText.toLowerCase()))
            .slice(0, 10)
            .map(p => ({value: `${p.zh_name} (${p.en_name})`, no: p.no}));
        setOptions(filtered);
    };

    const handleSelect = (value: string, option: any) => {
        const player = players.find(p => p.no === option.no);
        setSelectedPlayer(player || null);
    };

    return (
        <div style={{padding: 24, width: 400}}>
            <AutoComplete
                options={options}
                style={{width: '100%'}}
                onSearch={handleSearch}
                onSelect={handleSelect}
                placeholder="搜索球员姓名"
            />
            {selectedPlayer && (
                <Card style={{marginTop: 16}} title={selectedPlayer.zh_name}>
                    <Descriptions column={1} size="small">
                        <Descriptions.Item label="英文名">{selectedPlayer.en_name}</Descriptions.Item>
                        <Descriptions.Item label="国家/地区">{selectedPlayer.country}</Descriptions.Item>
                        <Descriptions.Item label="性别">{selectedPlayer.gender === 'woman' ? '女' : '男'}</Descriptions.Item>
                        <Descriptions.Item label="持拍手">{selectedPlayer.isRight === 'TRUE' ? '右手' : '左手'}</Descriptions.Item>
                        <Descriptions.Item label="握拍方式">{selectedPlayer.isStraight === 'TRUE' ? '直拍' : '横拍'}</Descriptions.Item>
                        <Descriptions.Item label="正手胶皮">{selectedPlayer.faceType0}</Descriptions.Item>
                        <Descriptions.Item label="反手胶皮">{selectedPlayer.faceType1}</Descriptions.Item>
                    </Descriptions>
                </Card>
            )}
        </div>
    );
};

export default PlayerQuery;